export const email = {
  hello: process.env.REACT_APP_HELLO_EMAIL ?? "",
  support: process.env.REACT_APP_SUPPORT_EMAIL ?? "",
};
